<div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
        <p class="fw-bold fs-5 mb-0">Quick Start Guide</p>
        <div class="btn-group" *ngIf="activeTab === 'esign'">
            <button class="btn btn-sm btn-primary" (click)="downloadEsignCurls()" title="Download as PDF">
                <i class="mdi mdi-file-pdf"></i>
            </button>
            <button class="btn btn-sm btn-primary" (click)="downloadEsignPostmanCollection()"
                title="Download Postman Collection">
                <i class="mdi mdi-download"></i>
            </button>
        </div>
        <div class="btn-group" *ngIf="activeTab === 'estamp'">
            <button class="btn btn-sm btn-primary" (click)="downloadEstampCurls()" title="Download as PDF">
                <i class="mdi mdi-file-pdf"></i>
            </button>
            <button class="btn btn-sm btn-primary" (click)="downloadEstampPostmanCollection()"
                title="Download Postman Collection">
                <i class="mdi mdi-download"></i>
            </button>
        </div>
    </div>
    <ng-container *ngIf="activeTab === 'esign'; else estampTab">

        <div class="card-body">

            <div class="row mb-3">
                <div class="label fw-semibold mb-1 d-flex justify-content-between align-items-center">
                    <span>1. Send Document via API</span>
                    <button class="btn btn-sm btn-outline-primary" (click)="copyToClipboard(curlCreateDoc, 'create')">
                        {{ copiedKey === 'create' ? 'Copied' : 'Copy' }}
                    </button>

                </div>

                <div class="text-muted small mb-2">Uploads a document and sends it to one or more signers for
                    electronic
                    signature.</div>
                <pre class="bg-light p-3 rounded text-start" [innerText]="curlCreateDoc"></pre>
                <div class="text-muted small mb-2 fst-italic">
                    Note: <code>esignType</code> indicates the signing method —
                    <code>"1"</code> for Aadhar,
                    <code>"2"</code> for DSC.
                    <code>"3"</code> for Aadhar Biometric.
                    <!-- <code>"3"</code> for OTP. -->
                </div>
            </div>

            @if(viewDoc){

            <div class="row mb-3">
                <div class="label fw-semibold mb-1 d-flex justify-content-between align-items-center">
                    <span>2. Get Document Status</span>
                    <button class="btn btn-sm btn-outline-primary" (click)="copyToClipboard(curlStatusDoc, 'status')">
                        {{ copiedKey === 'status' ? 'Copied' : 'Copy' }}
                    </button>

                </div>

                <div class="text-muted small mb-2">Fetch the current signing status of a document. </div>
                <pre class="bg-light p-3 rounded text-start" [innerText]="curlStatusDoc"></pre>
                <div class="text-muted small mb-2 fst-italic">
                    Note: Replace <code>documentId</code> with your actual document ID.
                </div>
            </div>

            <div class="row mb-3">
                <div class="label fw-semibold mb-1 d-flex justify-content-between align-items-center">
                    <span>3. Document Signed Download</span>
                    <button class="btn btn-sm btn-outline-primary"
                        (click)="copyToClipboard(curlDownloadDoc, 'download')">
                        {{ copiedKey === 'download' ? 'Copied' : 'Copy' }}
                    </button>

                </div>

                <div class="text-muted small mb-2">Downloads the final signed PDF document once signing is
                    completed. </div>
                <pre class="bg-light p-3 rounded text-start" [innerText]="curlDownloadDoc"></pre>
                <div class="text-muted small mb-2 fst-italic">
                    Note: Replace <code>documentId</code> with your actual document ID.
                </div>
            </div>

            <div class="row mb-3">
                <div class="label fw-semibold mb-1 d-flex justify-content-between align-items-center">
                    <span>4. Get All Documents</span>
                    <button class="btn btn-sm btn-outline-primary" (click)="copyToClipboard(curlAllDoc, 'all')">
                        {{ copiedKey === 'all' ? 'Copied' : 'Copy' }}
                    </button>

                </div>

                <div class="text-muted small mb-2">Retrieve a paginated list of all documents. </div>
                <pre class="bg-light p-3 rounded text-start" [innerText]="curlAllDoc"></pre>
            </div>

            <div class="row mb-3">
                <div class="label fw-semibold mb-1 d-flex justify-content-between align-items-center">
                    <span>5. Get Document By Id</span>

                    <button class="btn btn-sm btn-outline-primary" (click)="copyToClipboard(curlDoc, 'byId')">
                        {{ copiedKey === 'byId' ? 'Copied' : 'Copy' }}
                    </button>

                </div>

                <div class="text-muted small mb-2">
                    Fetch complete details of a specific document.
                </div>

                <pre class="bg-light p-3 rounded text-start" [innerText]="curlDoc"></pre>
                <div class="text-muted small mb-2 fst-italic">
                    Note: Replace <code>documentId</code> with your actual document ID.
                </div>
            </div>

            <div class="row mb-3">
                <div class="label fw-semibold mb-1 d-flex justify-content-between align-items-center">
                    <span>6. Send Document via Template Id</span>
                    <button class="btn btn-sm btn-outline-primary"
                        (click)="copyToClipboard(curlCreateDocWithTempId, 'createByTempId')">
                        {{ copiedKey === 'createByTempId' ? 'Copied' : 'Copy' }}
                    </button>

                </div>

                <div class="text-muted small mb-2">
                    Sends a predefined template (via templateId) to one or more signers for electronic signature.
                </div>
                <pre class="bg-light p-3 rounded text-start" [innerText]="curlCreateDocWithTempId"></pre>
                <div class="text-muted small mb-2 fst-italic">
                    Note: Replace <code>templateId</code> with your actual template ID.
                </div>
                <div class="text-muted small mb-2 fst-italic">
                    Note: <code>esignType</code> indicates the signing method —
                    <code>"1"</code> for Aadhar,
                    <code>"2"</code> for DSC.
                    <code>"3"</code> for Aadhar Biometric.
                    <!-- <code>"3"</code> for OTP. -->
                </div>
            </div>
            }
            <button class="btn btn-primary" (click)="viewDocumentataion()">
                {{ viewDoc ? '🙈 Hide Documentation' : '📖 View Full Documentation' }}
            </button>

        </div>
    </ng-container>
    <ng-template #estampTab>
        <ng-container *ngIf="activeTab === 'estamp'; else noData">
            <div class="card-body">
                <div class="row mb-3">
                    <div class="label fw-semibold mb-1 d-flex justify-content-between align-items-center">
                        <span>1. Get eStamp States List</span>
                        <button class="btn btn-sm btn-outline-primary"
                            (click)="copyToClipboard(estampStateList, 'estampStateList')">
                            {{ copiedKey === 'estampStateList' ? 'Copied' : 'Copy' }}
                        </button>
                    </div>

                    <div class="text-muted small mb-2">Retrieves a list of all available Indian states for eStamp
                        orders.</div>
                    <pre class="bg-light p-3 rounded text-start" [innerText]="estampStateList"></pre>
                    <div class="text-muted small mb-2 fst-italic">
                        Note: Use the stateId from this list when creating eStamp orders.
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="label fw-semibold mb-1 d-flex justify-content-between align-items-center">
                        <span>2. Create eStamp Order</span>
                        <button class="btn btn-sm btn-outline-primary"
                            (click)="copyToClipboard(createEstampOrder, 'createEstamp')">
                            {{ copiedKey === 'createEstamp' ? 'Copied' : 'Copy' }}
                        </button>
                    </div>

                    <div class="text-muted small mb-2">Creates an eStamp order with document details, party information,
                        and document file.</div>
                    <pre class="bg-light p-3 rounded text-start" [innerText]="createEstampOrder"></pre>
                    <div class="text-muted small mb-2 fst-italic">
                        Note: Replace <code>stateId</code>, <code>denomination</code>, <code>party</code>, and the
                        <code>file path</code> with your actual values.
                    </div>
                    <div class="text-muted small mb-2 fst-italic">
                        Note: <code>appendStampPosition</code> accepts <code>PRE</code> or <code>POST</code>.
                    </div>
                </div>
                @if(viewDoc){
                <div class="row mb-3">
                    <div class="label fw-semibold mb-1 d-flex justify-content-between align-items-center">
                        <span>3. Get eStamp Orders List</span>
                        <button class="btn btn-sm btn-outline-primary"
                            (click)="copyToClipboard(estampOrderList, 'estampOrderList')">
                            {{ copiedKey === 'estampOrderList' ? 'Copied' : 'Copy' }}
                        </button>
                    </div>

                    <div class="text-muted small mb-2">Retrieves a paginated list of all eStamp orders.</div>
                    <pre class="bg-light p-3 rounded text-start" [innerText]="estampOrderList"></pre>
                    <div class="text-muted small mb-2 fst-italic">
                        Note: Replace <code>page</code> and <code>limit</code> parameters to paginate through your
                        eStamp orders.
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="label fw-semibold mb-1 d-flex justify-content-between align-items-center">
                        <span>4. Get eStamp Inventory List</span>
                        <button class="btn btn-sm btn-outline-primary"
                            (click)="copyToClipboard(estampInventoryList, 'estampInventoryList')">
                            {{ copiedKey === 'estampInventoryList' ? 'Copied' : 'Copy' }}
                        </button>
                    </div>

                    <div class="text-muted small mb-2">Retrieves a paginated list of scanned eStamp inventory available
                        to your account.</div>
                    <pre class="bg-light p-3 rounded text-start" [innerText]="estampInventoryList"></pre>
                    <div class="text-muted small mb-2 fst-italic">
                        Note: Replace <code>page</code> and <code>limit</code> parameters to paginate through your
                        eStamp inventory.
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="label fw-semibold mb-1 d-flex justify-content-between align-items-center">
                        <span>5. Get eStamp Order Details</span>
                        <button class="btn btn-sm btn-outline-primary"
                            (click)="copyToClipboard(estampOrderDetail, 'estampOrderDetail')">
                            {{ copiedKey === 'estampOrderDetail' ? 'Copied' : 'Copy' }}
                        </button>
                    </div>

                    <div class="text-muted small mb-2">Fetches complete details of a specific eStamp order including
                        status, payment information, and document details.</div>
                    <pre class="bg-light p-3 rounded text-start" [innerText]="estampOrderDetail"></pre>
                    <div class="text-muted small mb-2 fst-italic">
                        Note: Replace <code>orderId</code> with your actual eStamp order ID.
                    </div>
                </div>
                }

                <button class="btn btn-primary" (click)="viewDocumentataion()">
                    {{ viewDoc ? '🙈 Hide Documentation' : '📖 View Full Documentation' }}
                </button>
            </div>
        </ng-container>
        <ng-template #noData>
            <div class="text-center fw-bold p-3">No Data available.</div>
        </ng-template>
    </ng-template>
</div>
